import { apiFetch } from './client';

const BASE = '/journeys';

/** List journeys (paged). */
export const list = ({ page = 0, size = 20, signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}`, { signal });

/** Get a journey by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/** Create a journey. */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a journey. */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a journey. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });

/** List touchpoints in a journey (paged). */
export const listTouchpoints = (journeyId, { page = 0, size = 20, signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints?page=${page}&size=${size}`, { signal });

/** Get a single touchpoint. */
export const getTouchpoint = (journeyId, touchpointId, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints/${touchpointId}`, { signal });

/** Create a touchpoint in a journey. */
export const createTouchpoint = (journeyId, body, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints`, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a touchpoint. */
export const updateTouchpoint = (journeyId, touchpointId, body, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints/${touchpointId}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a touchpoint. */
export const removeTouchpoint = (journeyId, touchpointId, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints/${touchpointId}`, { method: 'DELETE', signal });

/** Attach a label to a journey. */
export const attachLabel = (journeyId, labelUuid, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/labels/${encodeURIComponent(labelUuid)}`, { method: 'PUT', signal });

/** Detach a label from a journey. */
export const detachLabel = (journeyId, labelUuid, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/labels/${encodeURIComponent(labelUuid)}`, { method: 'DELETE', signal });

/** Attach a label to a touchpoint. */
export const attachTouchpointLabel = (journeyId, touchpointId, labelUuid, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints/${touchpointId}/labels/${encodeURIComponent(labelUuid)}`, { method: 'PUT', signal });

/** Detach a label from a touchpoint. */
export const detachTouchpointLabel = (journeyId, touchpointId, labelUuid, { signal } = {}) =>
  apiFetch(`${BASE}/${journeyId}/touchpoints/${touchpointId}/labels/${encodeURIComponent(labelUuid)}`, { method: 'DELETE', signal });
